//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import "@/mixins/global";
import chartOTP from "../../components/chartOTPDocument";
import axios, { CancelToken } from "axios";

export default {
  components: {
    chartOTP
  },
  data() {
    return {
      ps: "202001",
      pe: "202053",
      chartDoc: [],
      teamNYV11D: [],

      chartSample: [],
      teamNYV11S: [],
      api: `${this.$apiFix}`
    };
  },
  async mounted() {
    let a = await this.defaultPeriod();
    this.loadData();
  },
  methods: {
    defaultPeriod() {
      let params = new FormData();
      const obj = axios({
        method: "post",
        url: this.$api + "otpmaster.php/otperiod",
        data: params
      }).then(res => {
        this.ps = res.data.ps;
        this.pe = res.data.pe;
      });

      return obj;
    },

    loadData() {
      axios
        .get(`${this.api}otp_vn.php/doc_puma?ps=${this.ps}&pe=${this.pe}&team=`)
        .then(response => {
          this.chartDoc = response.data;
        });
      axios
        .get(
          `${this.api}otp_vn.php/doc_puma?ps=${this.ps}&pe=${this.pe}&team=NYV1-1`
        )
        .then(response => {
          this.teamNYV11D = response.data;
        });
      axios
        .get(
          `${this.api}otp_vn.php/sample_puma?ps=${this.ps}&pe=${this.pe}&team=`
        )
        .then(response => {
          this.chartSample = response.data;
        });
      axios
        .get(
          `${this.api}otp_vn.php/sample_puma?ps=${this.ps}&pe=${this.pe}&team=NYV1-1`
        )
        .then(response => {
          this.teamNYV11S = response.data;
        });
    },
    goPage(routerName) {
      this.$router.push({
        name: routerName
      });
    }
  }
};
